import { DeviceMobileIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Mobile = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <DeviceMobileIcon size={Sizes[size]} {...rest} />;
};

Mobile.displayName = 'Mobile';
